import React,{ useState, useEffect }  from 'react'
import {Card} from 'react-bootstrap'
import Sides from '../Bars/Diffjvsp';

import { Helmet } from "react-helmet";
import Button from 'react-bootstrap/Button'
function Jpwhile(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(3)
    } else {
      setWindowpadding(15)
    }
  }

  



return(
    <div>
   <Sides />
      <Helmet>
 
 <title>Difference Between Java and Python While tutorial For Beginners</title>
<meta name="description" content="Difference Between Java and Python While tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and  questions of all technology like java tutorial, python tutorial,python tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,programming language,While,tutorial for begineers,Difference Between Java and Python,Difference between program and code,java tutorial for begineers,python tutorial for begineers,C# tutorial for begineers,code,exampler,which online website to learn code,Difference Between Java and python tutorial,code,exampler,java vs python While,java vs Csharp(C#),While"/>
<link rel="canonical" href="https://www.codeexampler.com/java-vs-python-while" />
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Difference Between Java and Python While</h1>
    <div className="first">
        <a href="/java-vs-python-if-else"> <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-vs-python-function"> <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<h2 className="mt-4 mh2">
While loop :</h2>
<p className="mt-3 para">While loop condition will be given and the body of the loop will be executed until the given condition is false</p>


<h3 className="mt-4">while loop for java syntax:</h3>

<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">while loop java syntax</Card.Header>
  <Card.Body>
    <Card.Text>
    <span className="bl">While (condition) </span><br/>
    statement<br/>
    &#123;<br/>
    <span className="re">body</span><br/>
&#125;<br/>
    </Card.Text>
  </Card.Body>
</Card>

<h3 className="mt-4">While loop for python syntax:</h3>

<Card className='inde' border='primary m-4'>
  <Card.Header as="h4">Python while loop syntax</Card.Header>
  <Card.Body>
  
    <Card.Text>
    <span className="yl"> While (condition) </span><br/>
    statement<br/>
    <span className="re">body</span><br/>
    </Card.Text>
  </Card.Body>
</Card>


<h3 className="mt-4">While loop for java Example:</h3>

<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">while loop java Example</Card.Header>
  <Card.Body>
  
    <Card.Text>
    <span className="yl"> public</span> class <span className="re">Whileloop_example</span>&#47;&#47;<span className="gr"> class</span> is a <span className="bl">keyword</span><br/>
    &#123;<br/>
    <span className="re">public</span> static void main(String[] args) <br />
&#123;<br/>
<span className="bl">int</span> <span className="gr">a</span>=1;<br/>
<span className="yl">while</span>(<span className="gr">a</span>&#60;=10)<br/>
&#123;<br/>
System.out.<span className="gr">println</span>(<span className="re">a</span>);<br/>
<span className="yl">a++</span>;<br/><br/>
OR<br/><br/>
<span className="gr">a</span>=<span className="bl">a+1</span>;<br/>
&#125;<br/>
&#125;<br/>
&#125;<br/>
    </Card.Text>
  </Card.Body>
  <Card.Footer >Output-1<br/>
2<br/>
3<br/>
4<br/>
5<br/>
6<br/>
7<br/>
8<br/>
9<br/>
10</Card.Footer>
</Card>

<h3 className="mt-4">Python while loop example</h3>

<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">Q-While loops in python?</Card.Header>
  <Card.Body>
    <Card.Text>
<p>
<span className="re">a</span>=1<br/>
<span className="yl">while</span> <span className="bl">a</span>&#60;=5:<br/>
    print(<span className="gr">a</span>)<br/>
    <span className="re">a</span>=<span className="gr">a+1</span>

  </p>
    </Card.Text>
  </Card.Body>
  <Card.Footer>Output-<br/>1<br/>
2<br/>
3<br/>
4<br/>
5</Card.Footer>
</Card>

<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/java-vs-python-if-else">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-vs-python-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div>
    </div>
)

}
export default Jpwhile;